import { Outlet } from 'react-router'
import { useAuth, globalAdministratorRole } from '../auth'
import { NotFound } from '../common'

// Guards every page under /admin. The API's 403 is the real enforcement.
export const AdminRoute = () => (globalAdministratorRole(useAuth()) ? <Outlet /> : <NotFound />)
